import React from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchGroups } from '../server/requests';
import useResponseHandler from './useResponseHandler';

export const GROUP_TYPE_OWN_GROUP = 'USER_GROUP';
export const GROUP_TYPE_EXPERT_GROUP = 'EXPERT_GROUP';
export const GROUP_TYPE_PUBLIC_GROUP = 'PUBLIC_GROUP';
export const GROUP_TYPE_CAPTAIN_GROUP = 'CAPTAIN_GROUP';

const PAGE_SIZE = 5;

const useGroupInfiniteList = ({ groupType, enabled = true }) => {
    const { handleResponse } = useResponseHandler({
        requestHandler: fetchGroups,
    });

    const fetchGroupsWithPaging = (params) => {
        return handleResponse({
            pageNumber: params.pageParam || 1,
            pageSize: PAGE_SIZE,
            type: groupType,
        });
    };

    const getNextPageParam = (lastPage) => {
        return lastPage.totalNumberOfPages > lastPage.pageNumber
            ? lastPage.pageNumber + 1
            : undefined; // undefined means it's the last page
    };

    const {
        status,
        data,
        error,
        refetch,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
    } = useInfiniteQuery(['groups', groupType], fetchGroupsWithPaging, {
        getNextPageParam,
        //staleTime: 0,
        enabled: enabled,
    });

    return {
        data,
        error,
        status,
        refetch,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
    };
};

export default useGroupInfiniteList;
